import { BizAppConfig } from 'config/application.manifest';
import { createAppRequest } from '@/services/request';
import type { ApiRequestOptions } from './types/common';

const request = createAppRequest();

export interface AuthorizedResourceAction {
  name: string;
  description?: string;
}

export interface AuthorizedResource {
  effect?: string;
  code: string;
  type?: string;
  condition?: unknown;
  description?: string | null;
  actions?: string[];
  apiIdentifier?: string | null;
  namespaceId?: number | null;
}

export async function getMyAuthorizedResources(
  appId: string,
  options?: ApiRequestOptions,
) {
  const baseUrl = BizAppConfig.appTenantManagementUrl?.trim();
  const resolvedBaseUrl = baseUrl
    ? `${baseUrl.replace(/\/$/, '')}/`
    : '';

  return request<AuthorizedResource[]>(
    `${resolvedBaseUrl}bff/permission/me/authorized-resources`,
    {
      method: 'GET',
      params: { appId },
      ...(options || {}),
    },
  );
}
